<template>
  <div id="app">
    <!-- <router-view /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import axios from 'axios';
import { Dialog } from 'vant';
export default {
  name: 'App',
  created() {
    setInterval(() => {
      this.checkVersion();
    }, 10000);
  },
  methods: {
    checkVersion() {
      axios.get(`/static/version.json`, { headers: { 'Cache-Control': 'no-cache' } }).then((res) => {
        const version = res.data.version;
        const clientVersion = localStorage.getItem('_version_');
        // 和最新版本不同，刷新页面
        if (version !== clientVersion) {
          localStorage.setItem('_version_', version);
          Dialog.alert({
            title: '提示',
            message: '有新版本可用，点击更新'
          }).then(() => {
            window.location.reload();
          });
        }
      });
    }
  }
};
</script>
<style>
body {
    padding: 0px;
    margin: 0px auto;
}
a {
    text-decoration: none;
    color: #000;
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #000;
    margin-top: 60px;
    margin: 0 auto;
    /* max-width: 400px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue